var render = function render(){var _vm=this,_c=_vm._self._c;return _c('file-uploader',{staticClass:"p-5",attrs:{"value":_vm.files,"audio":_vm.audio,"maxFileCount":32},on:{"input":_vm.onFileInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }